module.exports = __webpack_public_path__ + "img/生态基地5.86e3f4cc.png";